import { render } from "./DadosEmpresa.vue?vue&type=template&id=215f1d9e&scoped=true"
import script from "./DadosEmpresa.vue?vue&type=script&lang=js"
export * from "./DadosEmpresa.vue?vue&type=script&lang=js"

import "./DadosEmpresa.vue?vue&type=style&index=0&id=215f1d9e&lang=scss&scoped=true"
import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&external"
import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215f1d9e"]])

export default __exports__